import React from 'react';
import { useTranslation } from 'react-i18next';

export function BoldConfig({ obj, handleBold, noPadding, index }) {
  const { t } = useTranslation('common');

  return (
    <div className={`${noPadding ? 'p-0' : 'p-2'}`}>
      <div className="bold-check-control mr-2">
        <input
          type="checkbox"
          id={typeof index === 'number' ? `bold_${index}` : 'bold'}
          onChange={handleBold}
          checked={obj?.otherConfiguration?.bold === true}
          name={typeof index === 'number' ? `bold_${index}` : 'bold'}
        />
        <label htmlFor={typeof index === 'number' ? `bold_${index}` : 'bold'} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.BOLD_CONFIG.BOLD')}>
          <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.BOLD_CONFIG.BOLD')}</span>
          <span className="icon-bold_new" />
        </label>
      </div>
    </div>
  );
}

export default BoldConfig;
